import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useUpdateUserRole } from "@/hooks/useUsers";
import { toast } from "sonner";
import type { UserRole } from "@/types";

const roleLabels: Record<UserRole, string> = {
  user: "Użytkownik",
  organizer: "Organizator",
  admin: "Administrator",
};

interface RoleSelectProps {
  userId: string;
  currentRole: UserRole;
}

export function RoleSelect({ userId, currentRole }: RoleSelectProps) {
  const updateRole = useUpdateUserRole();

  const handleChange = async (role: string) => {
    try {
      await updateRole.mutateAsync({ id: userId, role: role as UserRole });
      toast.success("Rola zaktualizowana");
    } catch (err) {
      toast.error("Nie udało się zaktualizować roli", {
        description: err instanceof Error ? err.message : undefined,
      });
    }
  };

  return (
    <Select value={currentRole} onValueChange={handleChange} disabled={updateRole.isPending}>
      <SelectTrigger className="w-36 h-8">
        <SelectValue>{roleLabels[currentRole]}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="user">Użytkownik</SelectItem>
        <SelectItem value="organizer">Organizator</SelectItem>
        <SelectItem value="admin">Administrator</SelectItem>
      </SelectContent>
    </Select>
  );
}
